module.exports = __webpack_public_path__ + "static/media/refresh.8cbe8e52.svg";